<div class="section-title" style="--_color-section: {{colorSection}};">
  <header>
    @if (!private) {
    <mat-icon *ngIf="svgIcon" svgIcon="{{svgIcon}}" class="section-icon"></mat-icon>
    <mat-icon *ngIf="icon" class="section-icon">{{icon}}</mat-icon>
    } @else {
    <mat-icon class="private" svgIcon="lock"></mat-icon>
    }
    <h2>{{title}}</h2>
    <h3 *ngIf="subtitle">{{subtitle}}</h3>
  </header>
  <button *ngIf="back" mat-icon-button color="primary" class="back" attr.aria-label="{{'general.back'|translate}}"
    (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
</div>